export enum TargetApp {
  Advertiser = 'advertiser',
  Webmaster = 'webmaster',
  Admin = 'admin',
}
